var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVehicleArrowDeparture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 11.75L20.2 6.55C20.1 6.25 19.8 6.05 19.5 6.05H17.3V4.55C17.3 4.15 17 3.75 16.5 3.75H4.50002V5.25H15.7V14.65C15 15.05 14.5 15.75 14.3 16.45H9.60002C9.20002 14.85 7.50002 13.85 5.90002 14.25C4.30002 14.65 3.30002 16.35 3.70002 17.95C4.10002 19.55 5.80002 20.55 7.40002 20.15C8.50002 19.85 9.30002 19.05 9.60002 17.95H14.3C14.7 19.55 16.3 20.55 17.9 20.15C19 19.85 19.8 19.05 20.1 17.95H21.7C22.1 17.95 22.5 17.65 22.5 17.15V11.95C22.5 11.85 22.5 11.75 22.5 11.65L22.4 11.75ZM6.80002 18.75C6.00002 18.75 5.30002 18.05 5.30002 17.25C5.30002 16.45 6.00002 15.75 6.80002 15.75C7.60002 15.75 8.30002 16.45 8.30002 17.25C8.30002 18.05 7.60002 18.75 6.80002 18.75ZM17.3 7.55H19.1L20.7 11.35H17.3V7.55ZM17.3 18.75C16.5 18.75 15.8 18.05 15.8 17.25C15.8 16.45 16.5 15.75 17.3 15.75C18.1 15.75 18.8 16.45 18.8 17.25C18.8 18.05 18.1 18.75 17.3 18.75ZM21 16.55H20.1C19.8 15.25 18.6 14.35 17.2 14.35V12.85H21V16.65V16.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 13.5L4.8 12.4L2.9 10.5L9 10.5L9 9L2.9 9L4.8 7.1L3.7 6L3.23464e-07 9.8L3.7 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVehicleArrowDeparture);
export default __webpack_public_path__ + "static/media/ic-vehicle-arrow-departure.8e009ed0034e140cebad00bd5b1a05fd.svg";
export { ForwardRef as ReactComponent };